import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';

const SecurityAdminRoute = () => {
    const { isSecurityAdmin} = useAuth();
    if (isSecurityAdmin()) {
        return <Outlet />;
    } else {
        <Navigate to={'/home'} />;
    }
};

export default SecurityAdminRoute;
